import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useFormContext } from 'react-hook-form';
import { radioOptions } from '../../../config/globals';
import { gridColumns } from '../../../config/layouts/grid';
import { Step3Data } from '../../../FormData.no.types';
import { CoAppFormGroup as CoAppFormGroupInternal } from './components';

export const CoApplicantFormGroup = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const addCoApplicant = watch('Frontend/AddCoApplicant');

  return (
    <>
      <Grid columns={gridColumns}>
        <RadioFieldUI<Step3Data>
          name="Frontend/AddCoApplicant"
          label={t('AddCoApplicant.label')}
          data-testid="add-co-applicant-radio"
          radioStyle="both"
          options={radioOptions}
        />
      </Grid>

      {addCoApplicant === 'Yes' && <CoAppFormGroupInternal />}
    </>
  );
};
